export default "__VITE_ASSET__DMeuQYv8__"